{
  "ascending": "αύξουσα",
  "ascendingSort": "διαλογή ανά στήλη {columnName} σε αύξουσα σειρά",
  "descending": "φθίνουσα",
  "descendingSort": "διαλογή ανά στήλη {columnName} σε φθίνουσα σειρά",
  "select": "Επιλογή",
  "selectAll": "Επιλογή όλων",
  "sortable": "Στήλη διαλογής"
}
